export default __webpack_public_path__ + "static/media/romance.8d4ca080.png";